import { RouteObject } from 'react-router';

import { CrmRoutePathKey } from '@anyx/common-routing';

import { routes as ChatRoutes } from '../chat/routing';

const PATH_KEY = CrmRoutePathKey.enum['tiktok-shop'];

export const routes: RouteObject[] = [
  {
    path: 'tiktok-shop',
    children: [...ChatRoutes(PATH_KEY)],
  },
];
